import type { RoomObservingSession, SketchingSessionRoom } from './visit-counsel.types';

/**
 * 스케치 방 메타와 `roomObserving[]` 세션을 매칭한다.
 * - `room.roomId`가 있으면 그걸로 조회 (가장 안전).
 * - 없으면 같은 (index, namePrefix)인 스케치 방의 `roomId`로 조회.
 * - 그것도 없을 때만 primary 방 나열 순서와 `roomObserving` 순서가 같다고 가정해 인덱스 폴백.
 *
 * 주의: `sketchingSession.rooms`에 추가공간이 섞여 있으면 전체 배열 인덱스로 `roomObserving[i]`를
 * 잡으면 안 된다. `roomObserving`은 일반 방만 있고 순서가 스케치와 다를 수 있다.
 */
export function resolveRoomObservingSessionForSketchRoom(
  room: Pick<SketchingSessionRoom, 'roomId' | 'namePrefix' | 'index'>,
  sketchRooms: SketchingSessionRoom[] | null | undefined,
  roomObserving: RoomObservingSession[]
): RoomObservingSession | undefined {
  if (room.roomId != null) {
    return roomObserving.find((s) => s.roomId === room.roomId);
  }
  const all = sketchRooms ?? [];
  const primaryRooms = all.filter((r) => !r.isAdditionalSpace);
  const sk = primaryRooms.find((r) => r.index === room.index && r.namePrefix === room.namePrefix);
  if (sk?.roomId != null) {
    return roomObserving.find((s) => s.roomId === sk.roomId);
  }
  const primaryIdx = primaryRooms.findIndex(
    (r) => r.index === room.index && r.namePrefix === room.namePrefix
  );
  if (primaryIdx >= 0 && primaryIdx < roomObserving.length) {
    return roomObserving[primaryIdx];
  }
  return undefined;
}
